<template>
  <div class="card shadow-1 q-px-lg">
    <div style="text-align: start">
      <h3 style="font-size: 20px; gap: 10px" class="flex">
        {{ $gettext('NEGOTIATION_DATA') }}
      </h3>
    </div>
    <div class="flex" style="gap: 10px; width: 100%;">
      <div class="flex column" style="color: #555; gap: 3px; width: 48%;">
        <q-card-section class="tw-bg-ice card-selection">
          <span class="text-subtitle2">
            {{ $gettext("CODE") }}:
            <!-- Lucas vai adicionar no webService -->
            <span class="text-subtitle1">{{ data.ds_referencia }}</span>
          </span>
        </q-card-section>
        <q-card-section class="card-selection">
          <span class="text-subtitle2">
            {{ $gettext("NEGOCIATION_DATE") }}:
            <span class="text-subtitle1">{{ moment(data.dt_registro).format('DD/MM/YYYY') }}</span>
          </span>
        </q-card-section>
        <q-card-section class="tw-bg-ice card-selection">
          <span class="text-subtitle2">
            {{ $gettext("TYPE_TRADING") }}:
            <!-- A = Acordo Simples  P = Parcelamento simples -->
            <span class="text-subtitle1">
              {{data.id_tipo_acordo == 'A' ? this.$gettext('SIMPLE_AGREEMENT') : this.$gettext('SIMPLE_INSTALLMENT_PAYMENT')}}
             </span>
          </span>
        </q-card-section>
        <q-card-section class="card-selection">
          <span class="text-subtitle2">
            {{ $gettext("CURRENT_SITUATION") }}:
            <!-- A = ativo C cancelado -->
            <span class="text-subtitle1">
              {{ data.id_status == "A" ? this.$gettext('ACTIVE') : this.$gettext('CANCELLED') }}
            </span>
          </span>
        </q-card-section>
        <q-card-section class="tw-bg-ice card-selection">
          <span class="text-subtitle2">
            {{ $gettext("TOTAL_NUMBER_INSTALLMENTS") }}:
            <span class="text-subtitle1">{{ data.qt_parcelas }}</span>
          </span>
        </q-card-section>
        <q-card-section class="card-selection">
          <span class="text-subtitle2">
            {{ $gettext("OBSERVATION") }}:
            <span class="text-subtitle1">{{ data.ds_obs }}</span>
          </span>
        </q-card-section>
      </div>
      <div class="flex column" style="color: #555; gap: 3px; width: 48%;">
        <q-card-section class="tw-bg-ice card-selection">
          <span class="text-subtitle2">
             <!-- Deixa campo em branco para quando não vier do sigre -->
            {{ $gettext("VALUE_OF_INSTALLMENTS") }}:
            <span class="text-subtitle1">{{ "" }}</span>
          </span>
        </q-card-section>
        <q-card-section class="card-selection">
          <span class="text-subtitle2">
            {{ $gettext("AMOUNT") }}:
            <span class="text-subtitle1">
              {{
                data.vl_total.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })
              }}
            </span>
          </span>
        </q-card-section>
        <q-card-section class="tw-bg-ice card-selection">
          <span class="text-subtitle2">
            {{ $gettext("AMOUNT_PAID") }}:
            <span class="text-subtitle1">
              {{
                amountPaid.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })
              }}
            </span>
          </span>
        </q-card-section>
        <q-card-section class="card-selection">
          <span class="text-subtitle2">
            {{ $gettext("OPEN_VALUE") }}:
            <span class="text-subtitle1">
              {{
                amountToPaid.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })
              }}
            </span>
          </span>
        </q-card-section>
        <!--Adicionar Valor pago e Valor em Aberto  ds_status_parcela -->
        <q-card-section class="tw-bg-ice card-selection">
          <span class="text-subtitle2">
            {{ $gettext("ADVISORY_FEE") }}:
            <span class="text-subtitle1">{{ data.vl_honorarios }}</span>
          </span>
        </q-card-section>
        <q-card-section class="card-selection q-mt-sm">
          <span class="text-subtitle2">
            {{ $gettext("ADVICE_TYPE") }}:
            <span class="text-subtitle1">{{ data.ds_assessoria }}</span>
          </span>
        </q-card-section>
      </div>
    </div>

  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import moment from 'moment'
@Component({
  name: 'Negociation',
  components: {},
  props: {
    data: Object
  }
})
class Negociation extends Vue {
  moment = moment
  get amountPaid () {
    return this.calcAllValues(this.data.parcelas_acordo_simples, 'vl_pago')
  }

  get amountToPaid () {
    return this.data.vl_total - this.amountPaid
  }

  calcAllValues (arr, atribute) {
    return arr.reduce((acumulador, obj) => {
      return acumulador + obj[atribute]
    }, 0)
  }
}
export default Negociation
</script>
<style scoped>
.card {
  height: 100%;
  width: 100%;
}
</style>
